<template>
    <div>
        <div>
            <title-field style="font-size: 24px">
                {{ $t('devis.devis_voyage.titre_stepr_1') }} &nbsp; :
            </title-field>
            <div class="row">
                <!-- Champ PAYS D'ORIGINE -->
                <div class="col-lg-6">
                    <div>
                        <sub-title style="display: block">
                            {{ $t('devis.devis_voyage.paysVoyage.Headline_1') }}
                        </sub-title>
                        <field-input 
                            style="width: 100%" 
                            v-model="countryOfOrigin"
                            readonly
                        />
                    </div>
                </div>

                <!-- Champ PAYS DE DESTINATION -->
                <div class="col-lg-6">
                    <div>
                        <sub-title style="display: block">
                            {{ $t('devis.devis_voyage.paysVoyage.Headline_2') }}
                        </sub-title>


        <!-- <div class="select-arrow" :class="{rotated: isDropdownOpen}">
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                <path d="M1 1.5L6 6.5L11 1.5" stroke="#666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div> -->

                       <div class="custom-select-container">
    <div class="custom-select" :class="{active: isDropdownOpen}" @click="toggleDropdown">
        <input 
            type="text"  
            v-model="searchCountry"
            :placeholder="destinationCountry ? destinationCountry.PAYS : 'Sélectionner le pays de destination'"
            class="select-input"
            @click.stop="openDropdown"
            @focus="openDropdown"
            @input="filterCountries"
            readonly
        />

    </div>
    <div class="options-container" v-show="isDropdownOpen">
        <div class="search-option">
            <input 
                type="text"  
                v-model="searchCountry"
                placeholder="Rechercher un pays..."
                class="search-input-in-options"
                @click.stop
                @input="filterCountries"
                ref="searchInput"
            />
        </div>
        <div 
            class="option" 
            v-for="(item, index) in filteredCountries" 
            :key="index"
            @click="selectCountry(item)"
        >
            {{ item.PAYS }}
        </div>
        <div class="no-results" v-if="filteredCountries.length === 0 && searchCountry">
            Aucun pays trouvé
        </div>
    </div>
</div>


                        <!-- <select 
                            name="destination" 
                            id="destination"
                            class="select-field"
                            v-model="destinationCountry"
                        >
                            <option disabled>
                                --Selectionner le pays de destination--
                            </option>
                            <option
                                v-for="(item, index) in listCountry"
                                :key="index"
                                :value="item"
                            >
                            {{ item.PAYS }}
                            </option>
                        </select> -->
                    </div>
                </div>
            </div>
        </div>

        <div>
            <title-field style="font-size: 24px">
                {{ $t('devis.devis_voyage.titre_stepr_2') }} &nbsp; :
            </title-field>

            <div class="row">
                <!-- champ date de départ -->
                <div class="col-lg-6">
                    <div>
                        <sub-title style="display: block">
                            {{ $t('devis.devis_voyage.dateVoyage.Headline_1') }}
                        </sub-title>
                        <DateInput 
                            label="DateDepart"
                            placeholder="Cliquer ici" 
                            @valueDate="dateDepartMethods"
                            :dateToDisabled="new Date()"
                            dayToDisabled="1"
                            stateToDisabled="before"
                            :default-date="defaultDepartureDate"
                        ></DateInput>
                    </div>
                </div>
                <!-- champ date de retour -->
                <div class="col-lg-6">
                    <div>
                        <sub-title style="display: block">
                            {{ $t('devis.devis_voyage.dateVoyage.Headline_2') }}
                        </sub-title>
                        <DateInput 
                            label="DateRetour"
                            placeholder="Cliquer ici" 
                            @valueDate="dateRetourMethods"
                            :dateToDisabled="departureDate"
                            stateToDisabled="before"
                            dayToDisabled="0"
                            :default-date="defaultArrivalDate"
                        ></DateInput>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-button">
            <button 
                type="button" 
                class="filled-button"
                @click="validationFields()"
            >
                {{$t('devis.devis_voyage.bouton_suivant')}}
            </button>
        </div>
    </div>
</template>

<script>
import ToastMixin from '../../../mixin/ToastMixin';
import DateInput from '../../layouts/FormInput/DateInput.vue'
import FieldInput from '../../layouts/FormInput/FieldInput.vue'
import SubTitle from '../../layouts/texts/SubTitle.vue'
import TitleField from '../../layouts/texts/TitleField.vue'
import { mapMutations } from 'vuex';
import { countryController } from '../../../packages/country/country.controller';
import dayjs from 'dayjs';

export default {
    name: 'VoyageComponent',
    mixins: [ToastMixin],
    components: {
        TitleField,
        SubTitle,
        FieldInput,
        DateInput
    },
    data() {
        return {
            countryOfOrigin: "Sénégal",
            destinationCountry: null,
            departureDate: null,
            arrivalDate: null,
            listCountry: [],
            searchCountry: "",
            isDropdownOpen: false
        }
    },
    computed: {
        filteredCountries() {
            if (!this.searchCountry) {
                return this.listCountry;
            }
            const searchTerm = this.searchCountry.toLowerCase();
            return this.listCountry.filter(country => 
                country.PAYS.toLowerCase().includes(searchTerm)
            );
        },
        defaultDepartureDate() {
            let container = this.$store.state.devisVoyageContainer
            if (container.travel) {
                this.dateDepartMethods(container.travel.departureDate)
                return container.travel.departureDate 
            }
            
            return ""; 
        },
        defaultArrivalDate() {
            let container = this.$store.state.devisVoyageContainer
            if (container.travel) {
                this.dateRetourMethods(container.travel.arrivalDate)
                return container.travel.arrivalDate 
            }
            
            return "";
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeDropdown);
    },
    methods: {
        openDropdown() {
        this.isDropdownOpen = true;
        this.$nextTick(() => {
            if (this.$refs.searchInput) {
                this.$refs.searchInput.focus();
            }
        });
    },
     // Fermer le dropdown quand on clique ailleurs sur la page
    closeDropdown(event) {
        if (!event.target.closest('.custom-select-container')) {
            this.isDropdownOpen = false;
        }
    },
    toggleDropdown() {
        if (this.isDropdownOpen) {
            this.isDropdownOpen = false;
        } else {
            this.openDropdown();
        }
    },
    selectCountry(country) {
        this.destinationCountry = country;
        this.searchCountry = country.PAYS; // Afficher le pays sélectionné
        this.isDropdownOpen = false;
    },
    filterCountries() {
        // Le filtrage se fait automatiquement via la computed property
    },
        ...mapMutations([
            "incrementStepper",
            "decrementStepper",
            "mutateContainerDevisVoyage",
            "resetContainerDevisVoyage"
        ]),

        dateRetourMethods(date) {
            this.arrivalDate = date
        },
        dateDepartMethods(date) {
            this.departureDate = date
        },
        validationFields() {
            if (this.countryOfOrigin === null || 
            this.destinationCountry === null|| 
            this.departureDate === null || 
            this.arrivalDate === null ) {
                return this.$toasted.show("Veuillez remplir tous les champs !", this.ToastTabError)
            }

            if (this.countryOfOrigin == this.destinationCountry) {
                return this.$toasted.show("Pays de destination doit être différent du pays de depart", this.ToastTabError)
            }

            this.mutateContainerDevisVoyage({
                travel: {
                    originCountry : this.countryOfOrigin,
                    destinationCountry: this.destinationCountry,
                    departureDate : dayjs(this.departureDate).format("YYYY-MM-DD"),
                    arrivalDate: dayjs(this.arrivalDate).format("YYYY-MM-DD")
                }
            })

            this.incrementStepper()
        },
        async getListCountry() {
            try {
                const country = await countryController
                this.listCountry = country.data.filter(
                    item => item.PAYS !== 'Sénégal'
                )
                console.log(':::::: liste des pays devis voyage :::::::', this.listCountry)
            } catch (error) {
                console.log("Error : ", error)   
            }
        }
    },
    mounted() {
        window.scrollTo(0, 0);
        this.getListCountry()
        if (this.$store.state.devisVoyageContainer.travel) {
        this.destinationCountry = this.$store.state.devisVoyageContainer.travel.destinationCountry;
        if (this.destinationCountry) {
            this.searchCountry = this.destinationCountry.PAYS;
        }
    } 
        // La liste reste fermée au chargement
    this.isDropdownOpen = false;
    // Ajouter un écouteur d'événements pour fermer le dropdown quand on clique ailleurs
    document.addEventListener('click', this.closeDropdown);

        // else {
            
        // }
    }
}
</script>

<style scoped>
    .bottom-button {
        display: flex;
        justify-content: end;
        align-items: center;
        height: 150px;
    }
    .filled-button {
        right: 0;
        padding: 12px 40px;
        border-radius: 50px;
        color: #fff;
        border: 1px solid #ffa409;
        background-color: #ffa409;
        font-size: 1.8rem;
        text-transform: uppercase;
        font-weight: 400;
    }











    



.custom-select-container {
    position: relative;
    width: 100%;
}

.custom-select {
    position: relative;
    width: 100%;
    height: 60px;
    border: 1px solid #d9dee3;
    border-radius: 12px;
    background-color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    min-height: 48px;
    display: flex;
    align-items: center;
}

.custom-select:hover {
    border-color: #d1d5db;
}

.custom-select.active {
    border-color: #ffa409;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.select-input {
    width: 100%;
    padding: 12px 40px 12px 16px;
    border: none;
    outline: none;
    background: transparent;
    font-size: 16px;
    color: #374151;
    cursor: pointer;
}

.select-input::placeholder {
    color: #9ca3af;
    font-size: 15px;
}

.select-arrow {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.select-arrow.rotated {
    transform: translateY(-50%) rotate(180deg);
}

.options-container {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    width: 100%;
    max-height: 280px;
    overflow-y: auto;
    background-color: white;
    border: 0.5px solid #d9dee3;
    border-radius: 12px;
    z-index: 1;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.search-option {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    background-color: #f9fafb;
}

.search-input-in-options {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    outline: none;
    font-size: 14px;
    background-color: white;
    transition: border-color 0.2s ease;
}

.search-input-in-options:focus {
    border-color: #ffa409;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.option {
    padding: 12px 16px;
    cursor: pointer;
    font-size: 15px;
    color: #374151;
    transition: background-color 0.15s ease;
    border-bottom: 0.5px solid #f3f4f6;
}

.option:last-child {
    border-bottom: none;
}

.option:hover {
    background-color: #f3f4f6;
}

.option:active {
    background-color: #e5e7eb;
}

.no-results {
    padding: 16px;
    color: #6b7280;
    font-style: italic;
    text-align: center;
    font-size: 14px;
}

/* Scrollbar personnalisée */
.options-container::-webkit-scrollbar {
    width: 6px;
}

.options-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.options-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.options-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}
</style>